import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  fetchTiposServicios,
  createTipoServicio,
  updateTipoServicio,
  deleteTipoServicio,
} from '../../api/administration/serviceTypeApi';

export const useServicesTypes = () => {
  const queryClient = useQueryClient();

  const { data: servicesTypes, isLoading, error } = useQuery({
    queryKey: ['tipos-servicios'],
    queryFn: fetchTiposServicios,
  });

  const createMutation = useMutation({
    mutationFn: createTipoServicio,
    onSuccess: () => {
      queryClient.invalidateQueries(['tipos-servicios']);
    },
  });

  const updateMutation = useMutation({
    mutationFn: ({ id, data }) => updateTipoServicio(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries(['tipos-servicios']);
    },
  });

  const deleteMutation = useMutation({
    mutationFn: deleteTipoServicio,
    onSuccess: () => {
      queryClient.invalidateQueries(['tipos-servicios']);
    },
  });

  return {
    servicesTypes,
    isLoading, 
    error,
    createMutation,
    updateMutation,
    deleteMutation,
  };
};
